var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on",
    transform: "translate(21832 19309)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10508",
    "data-name": "Ellipse 10508",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(-21832 -19309)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69668",
    "data-name": "Group 69668",
    transform: "translate(-21821.17 -19298.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19219",
    "data-name": "Rectangle 19219",
    width: 4.5,
    height: 14.4,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19220",
    "data-name": "Rectangle 19220",
    width: 4.5,
    height: 14.4,
    transform: "translate(9.84)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioPause);
export default __webpack_public_path__ + "static/media/icon-audio-pause.6581e064d64d5616b4107eca0d64ac7b.svg";
export { ForwardRef as ReactComponent };